import React, { useEffect, useLayoutEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { RangeDatePicker } from '../../../_common/Form/DatePickers/RangeDatePicker/RangeDatePicker';
import { useQuery } from '../../../../utils/hooks/useQuery';
import Button from '../../../_common/Form/Buttons/Button';
import classes from './repScorecards.module.scss';
import utils from '../../../../utils/utils';
import { getDashboardScriptWorkflowRequest } from '../../../../store/actions/dashboard';
import Loader from '../../../_common/Loader/Loader';
import TableAndPagination from '../../../_common/TableAndPagination/TableAndPagination';
import Api from '../../../../api/api';

const tableHeader = [
  {
    name: 'Status',
    path: 'status',
  },
  {
    name: 'Count',
    path: 'count',
  },
  // {
  //   name: 'Cancel Reason',
  //   path: 'reasons',
  // },
];

const collectRequestData = (requestData) => {
  const data = utils.deleteEmptyKeys(requestData);

  if (data.start) {
    if (!data.end) {
      data.end = moment(data.start).format('YYYY-MM-DD');
    } else {
      data.end = moment(data.end).format('YYYY-MM-DD');
    }
  }

  return data;
};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');

const ScriptWorkflow = () => {
  const { query, setQuery } = useQuery();

  const dispatch = useDispatch();
  const { dashboardScriptWorkflowData } = useSelector((store) => store.dashboard);

  const [requestData, setRequestData] = useState({
    start: query.start || thisMonthStartDay,
    end: query.start && !query.end ? '' : query.end || thisMonthEndDate,
  });

  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    (async () => {
      setLoading(true);

      await dispatch(getDashboardScriptWorkflowRequest(collectRequestData(requestData)));
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    const newQuery = utils.deleteEmptyKeys({ ...requestData });
    setQuery(newQuery);
  }, [requestData]);

  const onChangeDate = async (currentDate) => {
    setRequestData((prev) => ({ ...prev, start: currentDate[0], end: currentDate[1] }));

    const data = collectRequestData({ ...requestData, start: currentDate[0], end: currentDate[1] });
    setLoading(true);

    await dispatch(getDashboardScriptWorkflowRequest(data));
    setLoading(false);
  };

  const clearFilters = async () => {
    setLoading(true);

    const defaultRequestData = {
      start: thisMonthStartDay,
      end: thisMonthEndDate,
    };

    setRequestData(defaultRequestData);

    await dispatch(getDashboardScriptWorkflowRequest(defaultRequestData));

    setLoading(false);
  };

  const downloadButtonClick = async () => {
    await Api.getDashboardScriptWorkflow({ ...requestData, download: true });
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.wrapper_header}>
        <div style={{ marginRight: 10 }}>
          <RangeDatePicker
            currentDate={requestData}
            onChangeDate={onChangeDate}
            showLastYear
          />
        </div>

        <div className={classes.button_wrapper}>
          <Button
            title="Clear"
            clearButton
            onClick={clearFilters}
          />
        </div>

        <div className={classes.button_wrapper}>
          <Button
            downloadButton
            reverseColor
            className={classes.download_btn}
            title="Download"
            onClick={downloadButtonClick}
          />
        </div>
      </div>

      <div className={classes.table_wrapper} style={{ paddingBottom: 20 }}>
        {loading
          ? <Loader />

          : (
            <TableAndPagination
              data={dashboardScriptWorkflowData}
              header={tableHeader}
              hidePagination
            />
          )}
      </div>
    </div>
  );
};

ScriptWorkflow.propTypes = {
};

export default ScriptWorkflow;
